export default "__VITE_ASSET__D0havWk1__"